// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_SPACE } from "./action";

export function canGetSpace(scope: Scope): boolean {
  return scope.iamActions.includes(GET_SPACE);
}
